import { render } from "./WizardSlider.vue?vue&type=template&id=f24caf74&scoped=true"
import script from "./WizardSlider.vue?vue&type=script&lang=js"
export * from "./WizardSlider.vue?vue&type=script&lang=js"

import "./WizardSlider.vue?vue&type=style&index=0&id=f24caf74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24caf74"]])

export default __exports__